
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule, DataModule } from '@/store'

import AddressDto from '@/types/dto/addressDto'

	@Component({
	  name: 'AddressStatus'
	})
export default class AddressStatus extends Vue implements IAppForm {
  // #region Props

		@Prop() address!: AddressDto;
		@Prop() addressIndex!: number;
		@Prop({ default: false }) editing!: boolean;
		@Prop({ default: false }) isNew!: boolean;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		showStatusError = false;
		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit')
		}

		previous () {
		  this.$emit('previous')
		}

		validate () {
		  this.showStatusError = false

		  if (!this.address.residentialStatusLookup.id || this.address.residentialStatusLookup.id <= 0) {
		    this.showStatusError = true
		    return false
		  }

		  return true
		}

		setResidentialValue (val: number) {
		  this.showStatusError = false
		  this.address.residentialStatusLookup.id = val
		  setTimeout(() => { this.submit() }, 500)
		}

		// #endregion

		// #region Computed

		get residentialId () {
		  return this.value.addresses.length === 0 ? -1 : this.value.addresses[this.addressIndex].residentialStatusLookup ? this.value.addresses[this.addressIndex].residentialStatusLookup.id : undefined
		}

		get tenancyTypes () {
		  return DataModule.tenancyTypes
		}

		get editingAddressIndex () {
		  return ApplicationModule.editingAddressIndex
		}

		// #endregion

		// #region Watches

		@Watch('editingAddressIndex')
		changeEmployment () {
		  this.showStatusError = false
		}

  // #endregion
}
